import React from 'react';
import PropTypes from 'prop-types';
import SurveyDetails from './SurveyDetails';

class SurveyListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
  }

  componentDidUpdate(prevProps) {
    const { survey } = this.props;
    if (survey.get('id') !== prevProps.survey.get('id')) {
      this.setState({ isExpanded: false }); // eslint-disable-line react/no-did-update-set-state
    }
  }

  toggleSurveyItem = () => {
    const { isExpanded } = this.state;
    this.setState({ isExpanded: !isExpanded });
  };

  render() {
    const { isExpanded } = this.state;
    const { survey, routeId, stopId } = this.props;
    const expandedClassName = isExpanded ? 'route-survey-modal__survey-list-item--expanded' : '';

    const triggerEvent = Monet.I18n.getResourcesByKey('routeSurveyModal.surveyTrigger', (
      Monet.I18n.getResourcesByKey(
        Greenmile.Survey.SurveyApplyRule.triggerEvents[survey.getIn(['surveyApplyRule', 'surveyType'])]
      )
    ));
    const dateSubmitted = Monet.I18n.getResourcesByKey('routeSurveyModal.submittedAt', (
      Monet.Format.DateTime.formatToLocale(survey.get('when'))
    ));

    return (
      <div className={`route-survey-modal__survey-list-item ${expandedClassName}`}>
        <div className="route-survey-modal__survey-list-item__header" onClick={this.toggleSurveyItem}>
          <div className="route-survey-modal__survey-list-item__header-title">
            {survey.get('title', Monet.I18n.getResourcesByKey('routeSurveyModal.untitledSurvey'))}
          </div>
          <div className="route-survey-modal__survey-list-item__header-subtitle">
            {`${triggerEvent} • ${dateSubmitted}`}
          </div>
        </div>
        {isExpanded && 
          <SurveyDetails 
            survey={survey}
            routeId={routeId} 
            stopId={stopId}    
          />}
      </div>
    );
  }
}

SurveyListItem.propTypes = {
  // state
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  survey: PropTypes.object.isRequired
};

export default SurveyListItem;
